import {borderStyle} from '#core/utils/style-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';

import {generateAnimatedButton} from '#core/application/modules/tiles/button/index.js';
import {BET_FUNDS_INFO_TYPES, generateBetFundsInfo} from '#core/application/modules/tiles/bet-funds-info/index.js';

export function betslipPlaceBetTotalInfoFactory(PALETTE) {
    const {FONT} = PALETTE;

    const BETSLIP_PLACE_BET_TOTAL_INFO_NORMAL = generateBetFundsInfo(PALETTE.BETSLIP_PLACE_BET_TOTAL_INFO);
    const BETSLIP_PLACE_BET_TOTAL_INFO_EMPHASIZED = generateBetFundsInfo(
        PALETTE.BETSLIP_PLACE_BET_TOTAL_INFO,
        BET_FUNDS_INFO_TYPES.EMPHASIZED
    );

    return {
        PlaceBetCalculations: {
            totalPayoutInfo: {
                payout: {
                    betInfo: BETSLIP_PLACE_BET_TOTAL_INFO_EMPHASIZED,
                },
                prewager: {
                    cash: BETSLIP_PLACE_BET_TOTAL_INFO_NORMAL,
                    bonus: BETSLIP_PLACE_BET_TOTAL_INFO_NORMAL,
                },
                tax: {
                    betInfo: BETSLIP_PLACE_BET_TOTAL_INFO_NORMAL,
                },
                payoutAfterTax: {
                    betInfo: BETSLIP_PLACE_BET_TOTAL_INFO_EMPHASIZED,
                },
            },
            oddsBoostInfo: {
                betInfo: BETSLIP_PLACE_BET_TOTAL_INFO_NORMAL,
            },
            totalPayable: {
                betInfo: BETSLIP_PLACE_BET_TOTAL_INFO_EMPHASIZED,
            },
            prewagerStake: {
                cash: BETSLIP_PLACE_BET_TOTAL_INFO_NORMAL,
                bonus: BETSLIP_PLACE_BET_TOTAL_INFO_NORMAL,
            },
            freebetStake: {
                betInfo: BETSLIP_PLACE_BET_TOTAL_INFO_NORMAL,
            },
            cashStake: {
                betInfo: BETSLIP_PLACE_BET_TOTAL_INFO_NORMAL,
            },
            stakeTax: {
                betInfo: BETSLIP_PLACE_BET_TOTAL_INFO_NORMAL,
            },
            primaryTotalStake: {
                betInfo: BETSLIP_PLACE_BET_TOTAL_INFO_EMPHASIZED,
            },
            secondaryTotalStake: {
                betInfo: BETSLIP_PLACE_BET_TOTAL_INFO_NORMAL,
            },
            calculationsContainer: {
                style: {
                    padding: '0 0 4px 0',
                },
            },
        },
        PlaceBetButton: {
            buttonStyle: generateAnimatedButton(PALETTE.BETSLIP_PLACE_BET_BUTTON),
            potentialReturns: {
                style: {
                    fontWeight: FONT.WEIGHT_NORMAL,
                    fontSize: FONT.SIZE_XSMALL,
                },
            },
        },
        PlaceBetContent: {
            placeBetContainer: {
                style: {
                    ...resolveBackground(PALETTE.BETSLIP_PLACE_BET_TOTAL_INFO_CONTAINER_BG || 'inherit'),
                    ...borderStyle(0, PALETTE.BETSLIP_PLACE_BET_TOTAL_INFO_SEPARATOR_COLOR, '1px 0 0 0'),
                    fontSize: FONT.SIZE_MEDIUM,
                    fontWeight: FONT.WEIGHT_NORMAL,
                    padding: '8px',
                },
            },
        },
        PlacementMessages: {
            container: {
                style: {
                    padding: 0,
                    bottom: 24,
                    height: 40,
                    left: 12,
                    right: 8,
                },
            },
            errors: {
                info: {
                    text: {
                        style: {
                            fontSize: FONT.SIZE_XXSMALL,
                        },
                    },
                },
            },
        },
        TaxAbsorptionDisclaimer: {
            container: {
                style: {
                    padding: '4px 0 4px 8px',
                    borderStyle: 'solid',
                    borderWidth: '1px 0',
                    borderColor: PALETTE.BETSLIP_PLACE_BET_TOTAL_INFO_SEPARATOR_COLOR,
                },
            },
            text: {
                style: {
                    fontSize: FONT.SIZE_SMALL,
                    padding: '0 0 0 8px',
                    ...PALETTE.TAX_ABSORPTION_NOTIFICATION_TEXT,
                },
            },
            icon: {
                src: 'promotion-gift',
                style: {
                    fill: PALETTE.TAX_ABSORPTION_NOTIFICATION_ICON_COLOR,
                    minWidth: '16px',
                    minHeight: '16px',
                },
            },
        },
    };
}
